<template>
  <div class="columns is-multiline">
    <section class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
          <a @click="goTo('user')" class="button is-light is-radiusless">&lt; Regresar</a>
          <a @click="toggleInstructions()" class="button is-dark is-radiusless">Ayuda</a>
        </div>
        <form class="has-text-left">
          <div class="card-content">
            <h3 class="is-size-3">{{initTitle}}</h3>
            <br>
            <div class="columns is-multiline">
              <b-field label="Nombre*" class="column is-6">
                <b-input v-model="user.name"></b-input>
              </b-field>
              <b-field class="column is-6" label="correo*">
                <b-input v-model="user.email"></b-input>
              </b-field>
            </div>
          </div>
          <div class="card-footer">
            <button type="button" class="button is-warning is-radiusless" @click="submit()">Enviar</button>
            <button type="button" class="button is-default is-radiusless" @click="goTo('user')">Cancelar</button>
          </div>
        </form>
      </div>
    </section>
    <!-- help -->
    <section v-if="needHelp" class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
          <a @click="toggleInstructions()" class="button is-light is-radiusless">X Cerrar ayuda</a>
        </div>
        <div class="card-content">
          <h3 class="is-size-3">Ayuda</h3>
          <h3 class="is-size-4">Instrucciones</h3>
          <ul>
              <li>- Campos con (*) son requeridos</li>
            </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import VueCkeditor from 'vue-ckeditor2'
import UsersService from '@/services/UsersService'
import { xMisc } from '@/mixins/xMisc.js'
import { sGate } from '@/mixins/sGate.js'
export default {
  name: 'dashboard',
  mixins: [xMisc, sGate],
  components: {
    VueCkeditor
  },
  data () {
    return {
      mode: (this.$route.params.id) ? 'edit' : 'create',
      user: {
        name: null,
        email: null
      },
      needHelp: false,
      helpText: 'Ayuda',
      initTitle: 'Añadir nuevo usuario'
    }
  },
  mounted () {
    if (this.mode === 'edit') {
      this.initTitle = 'Editar cuenta'
      this.getData()
    }
  },
  methods: {
    async submit () {
      if (this.user.name == null) {
        this.alert('danger', 'Cuenta es requerida')
        return false
      }
      if (this.user.email == null) {
        this.alert('danger', 'Descripción es requerida')
        return false
      }
      var response = {}
      // POST
      if (this.mode === 'create') {
        response = await UsersService.addUser({data: this.user}, this.$session.get('user').token)
      } else if (this.mode === 'edit') {
        response = await UsersService.editUser({id: this.$route.params.id, data: this.user}, this.$session.get('user').token)
      }
      if (response.data.success) {
        if (this.mode === 'edit') {
          this.$toast.open({
            message: 'Cuenta actualizada',
            type: 'is-success'
          })
        } else {
          this.$toast.open({
            message: 'Cuenta creada',
            type: 'is-success'
          })
        }
        this.goTo('user')
      } else {
        this.alert('danger', 'Error, no se pudo crear la cuenta')
      }
    },
    async getData () {
      var response = await UsersService.getUser({id: this.$route.params.id}, this.$session.get('user').token)
      this.user.name = response.data.name
      this.user.email = response.data.email
    },
    toggleInstructions () {
      if (this.needHelp) {
        this.needHelp = false
        this.helpText = 'Ayuda'
      } else {
        this.needHelp = true
        this.helpText = 'Cerrar ayuda'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserForm.vue